import styled from 'styled-components'
import { BodyMedium, BodySmall } from '../typography/styled'

type LabelProps = {
  reverse?:boolean
}

export const Container = styled.div`
  display:flex;
  align-items:center;
  /* margin:4px; */
`

export const ToolTipImg = styled.img<LabelProps>`
  margin-left:${({reverse}) => reverse ? '' : '3px'};
  margin-right:${({reverse}) => reverse ? '4px' : ''};
  background-color: ${({reverse, theme}) => reverse ? theme.palette[10] : ''};
  border-radius: ${({reverse, theme}) => reverse ? theme.radius.xs : ''};
  box-shadow: ${({reverse, theme}) => reverse ? theme.shadows.control : ''};
  &:hover{
    cursor: pointer;
  }
`

export const LabelText = styled(BodyMedium)`
  color:${({theme}) => theme.palette[850]};
  /* word-break: break-word; */
`
export const SmallText = styled(BodySmall)`
  color:${({theme}) => theme.palette[800]};
`
export const LabelWrapper = styled.div<LabelProps>`
  display: flex;
  align-items: ${({reverse}) => reverse ? 'flex-start' : 'center'};
  /* justify-content: center; */
  flex-direction:${({reverse}) => reverse ? 'row-reverse' : 'row'};
  position: relative;
`

export const ToolTipView = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content:flex-start;
  padding: 8px 10px;
  z-index: 13;
  position: absolute;
  width: auto;
  width: 250px;
  /* white-space: nowrap; */
  /* word-wrap: break-word; */
  left:25px;
  top: -4px;
  background: ${({theme}) => theme.palette[10]};
  color:${({theme}) => theme.palette[850]};
  box-shadow: ${({theme}) => theme.shadows.menu};
  border-radius: ${({theme}) => theme.radius.control};
`

export const Zirochka = styled.span`
  color:${({theme}) => theme.accent[100]}!important;
`

export const DonutData = styled.div`
  display: flex;
  flex-direction: column;
  gap:5px;
  margin-bottom:10px;

`
